import React, { useEffect } from "react";
import { cardTitle } from "assets/jss/material-dashboard-pro-react";
import {
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  Select
} from "@material-ui/core";
import { masterApi } from "functions/apis";
import { Link } from "react-router-dom";
import Button from "components/CustomButtons/Button.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import PublishIcon from "@material-ui/icons/Publish";
import { token } from "functions/Helper";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import CardBody from "components/Card/CardBody";
import CustomInput from "components/CustomInput/CustomInput.js";
import ReactTable from "react-table";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const sortOptionList = ["Code Asc", "Code Desc", "Name Asc", "Name Desc"];

const useStyles = makeStyles(styles);

export default function InDraft() {
  const [pagination, setPagination] = React.useState({
    pageIndex: 1,
    pageSize: 10
  });
  const [filter, setFilter] = React.useState({
    searchString: "",
    publicationStatus: 0,
    sort: 0
  });
  const [pages, setPages] = React.useState(0);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const businessCategoryInDraftSignal = React.useRef(new AbortController());

  useEffect(() => {
    return () => businessCategoryInDraftSignal.current.abort();
  }, []);

  useEffect(() => {
    getBusinessCategoryData();
  }, [filter, pagination]);

  const getBusinessCategoryData = () => {
    setLoading(true);
    masterApi
      .get("BusinessCategories", {
        signal: businessCategoryInDraftSignal.current.signal,
        params: {
          filter,
          pagination
        }
      })
      .then(resp => {
        setData(
          resp.records.map(record => {
            return {
              ...record,
              actions: (
                <div className="actions-right">
                  <Link to={"/admin/BusinessCategory/Detail/" + record.id}>
                    <Button
                      color="info"
                      className="like"
                      type="button"
                      value="VIEW"
                    >
                      <VisibilityIcon /> VIEW
                    </Button>
                  </Link>
                  {(token["master.business_categories.write"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link to={"/admin/BusinessCategory/Edit/" + record.id}>
                      <Button color="danger" className="remove">
                        <EditIcon /> EDIT
                      </Button>
                    </Link>
                  )}
                  {(token["master.business_categories.write"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link to={"/admin/BusinessCategory/Delete/" + record.id}>
                      <Button color="danger" className="remove">
                        <DeleteIcon /> DELETE
                      </Button>
                    </Link>
                  )}
                  {(token["master.business_categories.publish"] === "allowed" ||
                    token.is_admin === "True") && (
                    <Link to={"/admin/BusinessCategory/Publish/" + record.id}>
                      <Button color="info" className="like">
                        <PublishIcon /> PUBLISH
                      </Button>
                    </Link>
                  )}
                </div>
              )
            };
          })
        );
        setPages(Math.ceil(resp.totalRecords / pagination.pageSize));
      })
      .catch(error => console.log(error))
      .finally(() => setLoading(false));
  };

  const handleSearchStringChanged = e =>
    setFilter({
      ...filter,
      searchString: e.target.value === "" ? null : e.target.value
    });

  const handleSortChanged = e =>
    setFilter({
      ...filter,
      sort: e.target.value === "" ? null : e.target.value
    });

  const classes = useStyles();

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>
              BUSINESS CATEGORIES IN DRAFT LIST
            </h4>
          </CardHeader>
          <CardBody>
            {(token["master.business_categories.write"] === "allowed" ||
              token.is_admin === "True") && (
              <Link to={"/admin/BusinessCategory/Create"}>
                <Button color="rose" type="button" value="Create">
                  Create Business Category
                </Button>
              </Link>
            )}
            <GridContainer>
              <GridItem xs={12} md={6}>
                <CustomInput
                  labelText="Search"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleSearchStringChanged,
                    value:
                      filter.searchString === null ? "" : filter.searchString
                  }}
                />
              </GridItem>
              <GridItem xs={12} md={6}>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <InputLabel htmlFor="selSort" className={classes.selectLabel}>
                    SORT BY
                  </InputLabel>
                  <Select
                    MenuProps={{
                      className: classes.selectMenu
                    }}
                    value={filter.sort ?? ""}
                    onChange={handleSortChanged}
                  >
                    {sortOptionList.map((record, key) => {
                      return (
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value={key}
                          key={key}
                        >
                          <p>{record}</p>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <ReactTable
                  manual
                  pages={pages}
                  page={pagination.pageIndex - 1}
                  pageSize={pagination.pageSize}
                  onPageChange={page =>
                    setPagination({
                      pageIndex: page + 1,
                      pageSize: pagination.pageSize
                    })
                  }
                  onPageSizeChange={(pageSize, page) => {
                    setPagination({ pageSize: pageSize, pageIndex: page + 1 });
                  }}
                  loading={loading}
                  data={data}
                  filterable={false}
                  columns={[
                    {
                      Header: "Code",
                      accessor: "code"
                    },
                    {
                      Header: "Name",
                      accessor: "name"
                    },
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
